export const standardError = bfTranslate('Oops! Something went wrong.');
